import { ApiUrl, sendToApi } from 'api/client'
import { ExportFormatEnum } from 'components/ExportModal/Types'
import { REACT_APP_ALMANAC_IMPORT_SERVICE_URL } from 'env'
import request from 'request-dot-js'

export const ExportClient = {
  createExport: (workspaceId: number, body: any, signal?: AbortSignal) => {
    return sendToApi<{ export_id: number }>(`/w/${workspaceId}/exports`, { method: 'POST', body, signal })
  },
  checkWorkspaceExportIsRunning: (workspaceId: number) => {
    return sendToApi<{ running: false } | { running: true; export_id: number; complete: number; total: number }>(
      `/w/${workspaceId}/workspace_exports/check_export_running`,
      {
        method: 'GET',
      },
    )
  },
  createWorkspaceExport: (workspaceId: number, exportFormat: ExportFormatEnum) => {
    return sendToApi<{ export_id: number; total: number }>(`/w/${workspaceId}/workspace_exports`, {
      method: 'POST',
      body: { export_format: exportFormat },
    })
  },
  cancelWorkspaceExport: (workspaceExportId: number) => {
    return sendToApi<string>(`/workspace_exports/${workspaceExportId}`, {
      method: 'DELETE',
    })
  },
  printPreview: (body: any) => {
    return fetch(`${REACT_APP_ALMANAC_IMPORT_SERVICE_URL}/print_preview`, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
  },
  getExportContent: (contentId: string) => {
    return fetch(`${REACT_APP_ALMANAC_IMPORT_SERVICE_URL}/export_content/${contentId}`, { method: 'GET' })
  },
  getSnapshot: (token: string) => {
    return request(`${ApiUrl}/snapshots`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
  },
  downloadExport: (almanacFileId: string, id: number) => {
    return sendToApi(`/almanac_files/${almanacFileId}/exports/${id}/download`, {
      method: 'GET',
      jsonOut: false,
    })
  },
  cancelExport: (export_id: number) => {
    return sendToApi<string>(`/exports/${export_id}`, {
      method: 'DELETE',
    })
  },
}
